// extracted by mini-css-extract-plugin
module.exports = {"headerProfileWrapper":"styles_headerProfileWrapper__9C5o0","buttonWrapper":"styles_buttonWrapper__IThL4","big":"styles_big__yBJ4Y"};